/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'truckin': {
    width: 11,
    height: 12,
    viewBox: '0 0 11 12',
    data: '<g _stroke="#376F99" _fill="none" fill-rule="evenodd" stroke-linecap="square"><path pid="0" d="M.375 11H9.75V2.73L5.375 1 1 2.73V3.7"/><path pid="1" d="M4.46 4.774L6.656 6.65 4.46 8.524"/></g>'
  }
})
